<template>
<div class='add-plot'>

    <button @click='close' class='add-btn close-btn'>Закрыть</button>
    <div class='flex-container-plot-list'>

        <div class='left-col'>
            <div>
                <span class='label'>Ширина ленты, м</span>
                <custom-p-input v-model='stripWidth' type='number' /><br>
            </div>
            <div>
                <!--<span class='label'>Площадь, га {{getArea.areaFakt > 0 ? "(факт: " + getArea.areaFakt.toFixed(2)+' га)': ''}}{{getArea.areaCorrect > 0 ? " (" + getArea.areaCorrect.toFixed(2)+' га)': ''}}</span>

<custom-p-input v-model='stripS' type='number'/><br>

-->
                <span class='label'>Длина ленты, вычисленная по координатам {{stripLengthCoord > 0 ? stripLengthCoord + ' м': ''}}</span><br><br>
                <span class='label'>Длина ленты по данным измерений</span>
                <custom-p-input v-model='stripLength' type='number' step=".1" />
                <span v-if="getArea.areaCoord" class='label'>Площадь ленты, вычисленная по координатам {{getArea.areaCoord > 0 ? getArea.areaCoord.toFixed(4)+' га': ''}}</span><br>
                <span v-if="stripS" class='label'>Площадь ленты по данным измерений {{stripS > 0 ? stripS +' га': ''}}</span>
            </div>
        </div>

        <div class='grid flex-item right-col'>

            <span class='coord-input-lat'>Широта</span>
            <span class='coord-input-lon'>Долгота</span>

            <span class='label'>Начало</span>
            <custom-p-input v-model='beginPoint.lat' type='number' step=".000001"/>
            <custom-p-input v-model='beginPoint.lon' type='number' />

            <template v-for='(point, i) in turningPointList'>
                <span :key="'label'+i" class='label'>Пов. точка {{ i + 1 }}</span>
                <custom-p-input :key="'lat_'+i" v-model='point.lat' type='number' />
                <custom-p-input :key="'lon_'+i" v-model='point.lon' type='number' />
                <button :key="'but_'+i" @click='removeTurningPoint(i)'>-</button>
            </template>

            <span class='label'>Конец</span>
            <custom-p-input v-model='endPoint.lat' type='number' />
            <custom-p-input v-model='endPoint.lon' type='number' />

            <div class='turning-points-block'>
                <custom-p-checkbox v-model='turningPointsAreExist' label='Поворотные точки' />
                <button @click='addTurningPoint' v-if='turningPointsAreExist'>+</button>
            </div>
        </div>
    </div>

    <div class='btn-row'>
        <button @click='save' class='add-btn'>Сохранить</button>
    </div>

</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import * as turf from '@turf/turf'
export default {
    name: 'TypeStripAddPlot',
    data() {
        return {
            stripWidth: null,
            stripS: null,
            stripLength: null,
            stripLengthCoord: 0,
            beginPoint: {
                lat: null,
                lon: null
            },
            endPoint: {
                lat: null,
                lon: null
            },

            turningPointsAreExist: false,
            turningPointList: [],
        };
    },
	props: {
		plot: {
			type: Object,
			default: null,
		}
	},
	mounted() {
		if (this.plot) {
			if (this.plot.points) {
				this.beginPoint = {
					lat: this.plot.points[0].lat,
					lon: this.plot.points[0].lon
				};
				this.endPoint = {
					lat: this.plot.points[this.plot.points.length - 1].lat,
					lon: this.plot.points[this.plot.points.length - 1].lon
				};
				if (this.plot.points.length > 2) {
					this.isInit = true;
					this.turningPointsAreExist = true;

					for (let i = 1; i < this.plot.points.length - 1; ++i) {
						const point = this.plot.points[i];
						const temp = {
							lat: point.lat,
							lon: point.lon
						};
						this.turningPointList.push(temp);
					}
				}
			}
			this.stripWidth = this.plot.radius_width
			this.stripLength = this.plot.length_manual||this.plot.length_calc
		}
	},
	beforeDestroy() {
		
	},
    computed: {
        lpo() {
            return this.$store.state.selectedLpo.lpo;
        },
        pointList() {
            const result = [];

            result.push(this.beginPoint);

            if (this.turningPointsAreExist) {
                for (const point of this.turningPointList) {
                    result.push(point);
                }
            }

            result.push(this.endPoint);

            return result;
        },
        pointList1() {
            const result = [];
            if (this.beginPoint.lat && this.beginPoint.lon) {
                result.push([+this.beginPoint.lon, +this.beginPoint.lat]);
            }
            if (this.turningPointsAreExist) {
                for (const point of this.turningPointList) {
                    if (point.lat && point.lon) {
                        result.push([+point.lon, +point.lat]);
                    }
                }
            }

            if (this.endPoint.lat && this.endPoint.lon) {
                result.push([+this.endPoint.lon, +this.endPoint.lat]);
            }
            return result;
        },
        getArea() {
            var areaCoord = 0
            const result = this.pointList1.reduce((acc, item) => {
                if (acc.filter((accitem) => {
                        return accitem[0] === item[0] && accitem[1] === item[1]
                    }).length > 0) {
                    return acc; // если значение уже есть, то просто возвращаем аккумулятор
                }
                return [...acc, item]; // добавляем к аккумулятору и возвращаем новый аккумулятор
            }, []);
            if (result.length > 1 && this.stripWidth) {
                if (!this.plot && this.stripLengthCoord != turf.length(turf.lineString(result), {units: 'meters'}).toFixed(1).replace('.0', '')) {
                    this.stripLength = turf.length(turf.lineString(result), {
                        units: 'meters'
                    }).toFixed(1).replace('.0', '')
                }
                this.stripLengthCoord = turf.length(turf.lineString(result), {
                    units: 'meters'
                }).toFixed(1).replace('.0', '')
                areaCoord = turf.length(turf.lineString(result), {
                    units: 'meters'
                }).toFixed(1).replace('.0', '') * this.stripWidth / 10000
                this.stripS = (this.stripLength * this.stripWidth / 10000).toFixed(4)
            } else if (result.length > 1) {
                areaCoord = 0
                this.stripS = 0
                this.stripLength = turf.length(turf.lineString(result), {
                    units: 'meters'
                }).toFixed(1).replace('.0', '')
                this.stripLengthCoord = turf.length(turf.lineString(result), {
                    units: 'meters'
                }).toFixed(1).replace('.0', '')
            } else {
                areaCoord = 0
                this.stripS = 0
                if (!this.plot) {
                    this.stripLength = null
                }
            	this.stripLengthCoord = null
            }
            return {
                areaCoord: areaCoord
            }
        },
        getArea1() {
            /*var point1 = turf.point([97.12261, 57.59284]);
            var point2 = turf.point([97.12223, 57.59488]);
            var point3 = turf.point([97.12139, 57.59502]);
            var point4 = turf.point([97.12072, 57.59223]);
            var a = function(point1, point2, point3) {
            	//var bearing_21 = turf.bearing(point2, point1);
            	//var bearing_23 = turf.bearing(point2, point3);
            	//bearing_21 = bearing_21 < 0 ? 360 + bearing_21: bearing_21
            	//bearing_23 = bearing_23 < 0 ? 360 + bearing_23: bearing_23
            	//var g = (bearing_21 - bearing_23)/2
            	//var a1 = bearing_21 - g
            	//var a2 = ((a1 + 180)/360-Math.round((a1 + 180)/360))*360
            	var bearing_21 = turf.rhumbBearing(point2, point1);
            	var bearing_23 = turf.rhumbBearing(point2, point3);
            	//var dest = turf.rhumbDestination(point2, 0.005, a1, {units: 'kilometers'});
            	return [bearing_21, bearing_23]
            }
            var b = function(point1,point2) {
            	var a1 = turf.rhumbBearing(point1, point2)
            	var dest = turf.rhumbDestination(point1, 0.005, a1+90+180, {units: 'kilometers'});
            	return [dest]
            }
            var c = function(width=5) {
            	var line = turf.lineString([[97.12261, 57.59284], [97.12223, 57.59488], [97.12139, 57.59502],[97.12072, 57.59223]]);
            	var offsetLeft = turf.lineOffset(line, -width, {units: 'meters'});
            	var offsetRight = turf.lineOffset(line, width, {units: 'meters'});
            	for (var i = offsetRight.geometry.coordinates.length-1; i >= 0 ; i--) {
            	offsetLeft.geometry.coordinates.push(offsetRight.geometry.coordinates[i])
            	}
            	offsetLeft.geometry.coordinates.push(offsetLeft.geometry.coordinates[0])
            	var poly = turf.polygon([offsetLeft.geometry.coordinates]);
            	var area = turf.area(poly)/10000
            	var buffered = turf.buffer(line, width/2, {units: 'meters', steps: 4});
            	return turf.area(buffered)/10000
            }
            console.log(c(20))
            //console.log(turf.angle(point1, point2, point3))
            */
            var area_fakt = 0
            var area_korrect = 0
            const result = this.pointList1.reduce((acc, item) => {
                if (acc.filter((accitem) => {
                        return accitem[0] === item[0] && accitem[1] === item[1]
                    }).length > 0) {
                    return acc; // если значение уже есть, то просто возвращаем аккумулятор
                }
                return [...acc, item]; // добавляем к аккумулятору и возвращаем новый аккумулятор
            }, []);
            if (result.length > 1 && this.stripWidth) {
                var pointPrev = turf.point(result[result.length - 2])
                var pointEnd = turf.point(result[result.length - 1])
                var bearing = turf.rhumbBearing(pointPrev, pointEnd);
                var dist = turf.rhumbDistance(pointPrev, pointEnd, {
                    units: 'meters'
                });
                var destination = turf.rhumbDestination(pointPrev, dist + Number(this.stripLength), bearing, {
                    units: 'meters'
                });
                var probaKor = result.slice(0, -1)
                probaKor.push(destination.geometry.coordinates)
                var fakt = turf.buffer(turf.lineString(result), this.stripWidth / 2, {
                    units: 'meters',
                    steps: 4
                });
                area_fakt = turf.area(fakt) / 10000
                var correct = this.stripLength ? turf.buffer(turf.lineString(probaKor), this.stripWidth / 2, {
                    units: 'meters',
                    steps: 4
                }) : null
                area_korrect = correct ? turf.area(correct) / 10000 : 0
                var stripLength = turf.length(turf.lineString(result), {
                    units: 'meters'
                })
                var stripLengthKor = turf.length(turf.lineString(probaKor), {
                    units: 'meters'
                })
            } else {
                area_fakt = 0
                area_korrect = 0
                stripLength = 0
                stripLengthKor = 0
            }
            return {
                areaFakt: area_fakt,
                areaCorrect: area_korrect,
                stripLength: stripLength,
                stripLengthKor: stripLengthKor
            }
        }
    },
    watch: {
        /*turningPointsAreExist(checked) {
            if (checked) {
                const temp = {
                    lat: null,
                    lon: null
                };
                this.turningPointList.push(temp);
            } else {
                this.turningPointList.splice(0);
            }
        }*/
    },
    methods: {
        addTurningPoint() {
            const temp = {
                lat: null,
                lon: null
            };
            this.turningPointList.push(temp);
        },
        removeTurningPoint(i) {
            this.turningPointList.splice(i, 1);

            if (!this.turningPointList.length) {
                this.turningPointsAreExist = false;
            }
        },

        save() {
            if (this.stripWidth === null || this.stripWidth === '') {
                console.log('no width');
                return;
            }

            for (let point of this.pointList) {
                if (point.lat === null || point.lat === '' ||
                    point.lon === null || point.lon === '') {
                    console.log('not all points');
                    return;
                }
            }

			if (this.plot) {
				const temp = {
					plot: this.plot,
					s: this.stripS,
					width: this.stripWidth,
					lengthManual: this.stripLength,
					pointList: this.pointList
				};
				this.editPlotStrip(temp).then(res => {
					this.updatePlotList(this.lpo.lpo_id);
					this.close();
				});
			} else {
				const temp = {
					lpo: this.lpo,
					s: this.stripS,
					width: this.stripWidth,
					lengthManual: this.stripLength,
					pointList: this.pointList
           		};
				this.addPlot(temp).then(res => {
					this.updatePlotList(this.lpo.lpo_id);
                    this.close();
				});
			}

        },

        close() {
            this.$emit('close');
        },

        ...mapActions('selectedLpo/recount', [
            'addPlot',
            'updatePlotList',
			'editPlotStrip'
        ])
    }
};
</script>

<style scoped src='@/style/flex.css'></style>

<style scoped>
.close-btn {
    float: right;
}

.flex-container-plot-list {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.left-col {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 50%;
    text-align: start;
}

.left-col .p-custom-input-container {
    width: 150px;
}

.btn-row {
    margin-top: 10px;
}

.btn-row>button:first-child {
    margin-right: 10px;
}

.add-plot {
    background-color: #eee;
    border: 1px solid black;
    padding: 20px;
    /*width: 350px;*/
    max-width: 100%;
}

.flex-container {
    gap: 20px;
}

.grid {
    display: grid;
    grid-template-columns: [label] auto [input-lat] 1fr [input-lon] 1fr [turning-btn] auto;
    grid-gap: 4px;
}

.turning-points-block {
    grid-column: span 3;
    display: flex;
    gap: 1rem;
}

.label {
    grid-column: label;
    grid-row: auto;
}

.width-input {
    grid-column: span 2;
}

.coord-input-lat {
    grid-column: input-lat;
    grid-row: auto;
}

.coord-input-lon {
    grid-column: input-lon;
    grid-row: auto;
}

.add-btn {
    grid-column: span 3;
}
</style>
